import { gql } from 'apollo-angular';

export const GET_INVITATION_STATUS = gql`
  query ($hash: String!) {
    invitationStatus(hash: $hash) {
      status
    }
  }
`;
